import { render } from "./Slides.vue?vue&type=template&id=412afa01&scoped=true"
import script from "./Slides.vue?vue&type=script&lang=js"
export * from "./Slides.vue?vue&type=script&lang=js"

import "./Slides.vue?vue&type=style&index=0&id=412afa01&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-412afa01"]])

export default __exports__